import { z } from "zod";
import { createOptionsFrom } from "@/lib/common/Option";

export const CurrencyLabels = {
	AUD: "AUD",
	CAD: "CAD",
	EUR: "EUR",
	GBP: "GBP",
	IDR: "IDR",
	NZD: "NZD",
	SGD: "SGD",
	USD: "USD",
	JPY: "JPY"
} as const;

export type Currency = keyof typeof CurrencyLabels;

export const CurrencyOptions = createOptionsFrom(CurrencyLabels);

export const CurrencySchema = z.enum(
	Object.keys(CurrencyLabels) as Currency[]
);
